var chunkMapping = {
	"1415": [
		71415
	],
	"2265": [
		72265
	],
	"4851": [
		44851
	],
	"7241": [
		77241
	]
};
var idToExternalAndNameMapping = {
	"44851": [
		"default",
		"./SettingsRoutes",
		50954
	],
	"71415": [
		"default",
		"./TeamRoutes",
		50954
	],
	"72265": [
		"default",
		"./MenuRoutes",
		50954
	],
	"77241": [
		"default",
		"./AccountRoutes",
		50954
	]
};
var idToRemoteMap = {
	"44851": [
		{
			"externalType": "module",
			"name": ""
		}
	],
	"71415": [
		{
			"externalType": "module",
			"name": ""
		}
	],
	"72265": [
		{
			"externalType": "module",
			"name": ""
		}
	],
	"77241": [
		{
			"externalType": "module",
			"name": ""
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"44851": {
		"shareScope": "default",
		"name": "./SettingsRoutes",
		"externalModuleId": 50954,
		"remoteName": ""
	},
	"71415": {
		"shareScope": "default",
		"name": "./TeamRoutes",
		"externalModuleId": 50954,
		"remoteName": ""
	},
	"72265": {
		"shareScope": "default",
		"name": "./MenuRoutes",
		"externalModuleId": 50954,
		"remoteName": ""
	},
	"77241": {
		"shareScope": "default",
		"name": "./AccountRoutes",
		"externalModuleId": 50954,
		"remoteName": ""
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}